import styled from 'theme';

export const Link = styled.a``;
